import styles from 'components/ContentLinkV2/CustomIconLink.module.scss';

import React from 'react';

import type { HasCustomIcon, Link } from 'api/contentful/contentTypes.cloverdotcom';
import { ContentImage } from 'components/ContentImage/ContentImage';
import { ContentLinkV2, IContentLinkV2Props } from 'components/ContentLinkV2/ContentLinkV2';
import type { FlatEntry } from 'services/cms/flattenContentful';

export interface ICustomIconLinkProps<T extends FlatEntry<Link> = FlatEntry<HasCustomIcon>>
  extends Omit<IContentLinkV2Props, 'entry'> {
  entry?: T;
  customIconClassName?: string;
  isFullWidth?: boolean;
}

export const CustomIconLink = React.forwardRef<HTMLAnchorElement, ICustomIconLinkProps>(
  ({ className, customIconClassName, isFullWidth, ...props }, ref) => {
    const { customIcon } = props.entry || {};
    if (!customIcon) return null;

    return (
      <ContentLinkV2 {...props} className={styles.customIconLink} ref={ref} hideTitle>
        <ContentImage entry={customIcon} className={customIconClassName} />
      </ContentLinkV2>
    );
  },
);

CustomIconLink.displayName = 'CustomIconLink';
